import { gql } from "@apollo/client"; import { useLazyQuery } from "@apollo/client/react"; import React, { useState, useEffect, useRef } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Outlet } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import ErrorDialog from '../../../components/ErrorDialog';
import { Avatar, Box, Button, Card, CardContent, InputAdornment, Stack, TextField } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PersonIcon from '@mui/icons-material/Person';
import DeleteIcon from '@mui/icons-material/Delete';



export default function SeccionPaciente({ delegs, pacienteSeleccionado, setPacienteSeleccionado }) {
  const [datos, setDatos] = useState('');
  const [dataOriginal, setDataOriginal] = useState('');

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const txtBuscar = useRef(null);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    txtBuscar.current.focus();
    getPacientes({ variables: { delegaciones: delegs } });
  }, [delegs]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const QGetPacientes = gql`
    query QGetPacientes ($delegaciones: [Int!]!) {
        pacientes (delegaciones: $delegaciones)
            {
                success,
                error,
                valorEsperado {
                    idPaciente,
                    idDelegacion,
                    apellido,
                    nombre,
                    tipoDocumento,
                    numeroDocumento,
                    numeroAfiliado
                }
            }
    }`;

  const [getPacientes, { error: errorPacientes, data: dataPacientes }] = useLazyQuery(QGetPacientes, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataPacientes?.pacientes?.success) return;

    const dataAll = dataPacientes.pacientes.valorEsperado;
    setDatos(dataAll);
    setDataOriginal(dataAll);
  }, [dataPacientes]);

  useEffect(() => {
    if (!errorPacientes) return;

    setMensajeError("ERRORDB");
  }, [errorPacientes]);


  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscar.current.value != "") {
      if (txtBuscar.current.value.length >= 3) {
        setDatos(dataOriginal.filter((dataOriginal) => {
          const nombreBuscar = dataOriginal.nombre.toLowerCase();
          const apellidoBuscar = dataOriginal.apellido.toLowerCase();
          const numeroDocumentoBuscar = dataOriginal.numeroDocumento.toLowerCase();

          const inputBuscar = txtBuscar.current.value.toLowerCase();
          return (
            nombreBuscar.includes(inputBuscar) ||
            apellidoBuscar.includes(inputBuscar) ||
            numeroDocumentoBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      getPacientes({ variables: { delegaciones: delegs } });
      setDatos(dataOriginal);
    }
  };

  const handleClean = () => {
    txtBuscar.current.value = "";
    handleSearch();
    txtBuscar.current.focus();
  };

  const generarGrilla = () => {
    const columns = [

      { field: 'idPaciente', align: 'center', headerName: 'Id', flex: 0.1, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'apellido', headerName: 'Apellido', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'nombre', headerName: 'Nombre', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'tipoDocumento', align: 'center', headerName: 'Tipo Doc.', flex: 0.1, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'numeroDocumento', align: 'center', headerName: 'Número Documento', minWidth: 60, flex: 0.2, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'numeroAfiliado', align: 'center', headerName: 'Número Afiliado', minWidth: 60, flex: 0.2, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' }];



    return columns;
  };

  // Click sobre fila de la grilla de búsqueda de roles disponibles
  const handleRowClick = (params) => {
    let agregar = true;

    if (pacienteSeleccionado != null && pacienteSeleccionado.idPaciente > 0) {
      // verifico que no haya sido seleccionado anteriormente
      const nodo = pacienteSeleccionado.filter((item) => item.idPaciente === params.row.idPaciente);
      if (nodo.length > 0) {
        agregar = false;
        toast.error("El Paciente ya se encuentra seleccionado");
      }
    }

    if (agregar) {
      setPacienteSeleccionado(params.row);
    }
  };

  return (
    <>
      <Stack direction="row" spacing={100} alignItems="center">
        <Box className='botonera-superior-left-search'>
          <TextField
            className="input-300"
            label="Filtrar paciente"
            name="txtBuscar"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtBuscar}
            onKeyUp={handleSearch}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: 'pointer' }} />

                  <ClearIcon
                    onClick={handleClean}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </Box>
      </Stack>
      <br />

      <DataGridGenerico
        columns={generarGrilla()}
        onRowClick={handleRowClick}
        rows={datos}
        toolbar={false} />


      <br />
      <Card sx={{ padding: '5px', paddingTop: '0px', width: '50%' }}>
        <h4>Paciente seleccionado</h4>
        <div style={{ display: 'flex', width: '100%', paddingBottom: '5px' }}>
          <div style={{ width: '10%', paddingLeft: '5px' }}>
            <Avatar sx={{ bgcolor: pacienteSeleccionado != "" && pacienteSeleccionado != null && pacienteSeleccionado.idPaciente > 0 ? '#82E0AA' : 'grey' }}>
              <PersonIcon />
            </Avatar>
          </div>
          {pacienteSeleccionado != "" && pacienteSeleccionado != null && pacienteSeleccionado.idPaciente > 0 &&
            <>
              <div style={{ padding: '6px', fontWeight: '600' }}>
                {pacienteSeleccionado.apellido} {pacienteSeleccionado.nombre} - {pacienteSeleccionado.tipoDocumento} {pacienteSeleccionado.numeroDocumento} - ID {pacienteSeleccionado.idPaciente}
              </div>
              <div style={{ padding: '5px' }}>
                <DeleteIcon sx={{ cursor: 'pointer', color: '#818181' }} onClick={() => setPacienteSeleccionado("")} />
              </div>
            </>
          }
        </div>
      </Card>

      <Outlet />



      <ErrorDialog
        id="dlg-error-paciente"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />


    </>);


};